import QrScanner from 'qr-scanner';
import { useEffect, useRef, useState } from 'react';
import { useLogin } from '../pages/Home/Home.utils';

interface QRScannerProps {
  onClose: () => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ onClose }) => {
  const videoElementRef = useRef<HTMLVideoElement | null>(null);
  const [scannedText, setScannedText] = useState('');
  const [error, setError] = useState<string | null>(null);

  const { login } = useLogin();

  useEffect(() => {
    const video = videoElementRef.current;
    if (!video) return;

    let qrScanner: QrScanner | null = new QrScanner(
      video,
      (result) => {
        //console.log('Decoded QR Code:', result);
        if(result.data !== scannedText){
          setScannedText(result.data);
        }
      },
      {
        returnDetailedScanResult: true,
        highlightScanRegion: true,
        highlightCodeOutline: true,
      }
    );

    const startScanner = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } } });
        await qrScanner?.start();
        console.log('QR Scanner started');
      } catch (err) {
        console.error('Error starting QR scanner:', err);
        setError('Cannot access the camera. Please check permissions.');
      }
    };

    startScanner();

    return () => {
      console.log('Stopping QR scanner');
      qrScanner?.stop();
      qrScanner?.destroy();
      qrScanner = null;
    };
  }, []);

  useEffect(() => {
    if(scannedText !== ''){
      console.log("Próba logowania - Zeskanowano QR:", scannedText)
      login(scannedText);
      onClose()
    }
  },[scannedText])

  return (
    <div>
      <div className="flex items-center justify-center mb-2 mt-2 p-1">
        <video
          ref={videoElementRef}
          className="w-full max-w-md h-auto max-h-[70vh] object-contain"
        />
      </div>
      {/* {error && <p className="text-red">Error: {error}</p>}
      <p className="break-words my-2 font-bold">SCANNED: {scannedText}</p> */}
    </div>
  );
};

export default QRScanner;
